/**
 * User Media Like Remapper
 * Flutter: lib/data/models/user_media_like.dart
 */
import type { UserMediaLikeDto } from '@/data/dtos/userMediaLike/userMediaLikeDto';
import type { JsonObject } from '@/data/types/json';
import type { ContentLikedUserEntity } from '@/domain/entities/contentReaction/contentLikedUserEntity';
import type { UserMediaLikeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class UserMediaLikeRemapper {
  static toStorage(dto: UserMediaLikeDto): UserMediaLikeStorage {
    return {
      mediaId: dto.mediaId,
      userId: dto.userId,
      peerUserId: dto.peerUserId,
      path: dto.path,
      liked: dto.liked,
      createdDate: dto.createdDate,
      updatedDate: dto.updatedDate,
      username: dto.username,
    };
  }

  static toDto(storage: UserMediaLikeStorage): UserMediaLikeDto {
    return {
      mediaId: storage.mediaId,
      userId: storage.userId,
      peerUserId: storage.peerUserId,
      path: storage.path,
      liked: storage.liked,
      createdDate: storage.createdDate,
      updatedDate: storage.updatedDate,
      username: storage.username,
    };
  }

  static fromJson(data: JsonObject): UserMediaLikeDto {
    return {
      mediaId: (data['mediaId'] as string | undefined) ?? '',
      userId: (data['userId'] as string | undefined) ?? '',
      peerUserId: (data['peerUserId'] as string | undefined) ?? '',
      path: (data['path'] as string | undefined) ?? '',
      liked: (data['liked'] as boolean | undefined) ?? false,
      createdDate: (data['createdDate'] as number | undefined) ?? 0,
      updatedDate: data['updatedDate'] as number | undefined,
      username: (data['username'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): UserMediaLikeDto[] {
    return dataList.map(UserMediaLikeRemapper.fromJson);
  }

  static toEntity(dto: UserMediaLikeDto): ContentLikedUserEntity {
    return {
      userId: dto.userId,
      username: dto.username,
    };
  }
}
